import styled from "styled-components";

import { sizes } from "../../variables";

export const Container = styled.div`
  width: 100%;
  margin-bottom: ${({ mobile }) => (mobile ? 0 : sizes.xl4)};
  .banner-logo {
    display: none;
  }
  @media screen and (max-width: 379px) {
    font-size: 6px;
    img {
      width: 50%;
    }
    .steps {
      width: 80%;
    }
    .banner-logo {
      display: unset;
    }
  }

  @media screen and (min-width: 380px) and (max-width: 500px) {
    font-size: 8px;
    .steps {
      width: 80%;
    }
    .steps-mobile {
      width: 70%;
    }
    .banner-logo {
      display: unset;
    }
  }

  @media screen and (min-width: 501px) and (max-width: 800px) {
    font-size: 10px;
    img {
      width: 40%;
    }

    .steps-mobile {
      margin-top: ${sizes.xl2};
      width: 60%;
    }

    .steps {
      margin-top: ${sizes.xl2};
      width: 100%;
    }
    .banner-logo {
      display: unset;
    }
  }
`;

export const ImageContainer = styled.div`
  margin-top: ${sizes.lg};
  width: 100%;
  display: flex;
  justify-content: center;

  .steps-mobile {
    display: none;
  }
  .steps {
    display: block;
    width: 100%;
  }

  .gallery-mobile {
    display: none;
  }

  .gallery {
    display: block;
  }

  img {
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    .steps-mobile {
      display: block;
    }
    .steps {
      display: none;
    }
    .gallery-mobile {
      display: block;
    }
  
    .gallery {
      display: none;
    }
  }
`;
